"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
exports.ContentFeedPushIndividualItemsToggle = ({ toggle, on, }) => {
    return (react_1.default.createElement(reactstrap_1.FormGroup, null,
        react_1.default.createElement(reactstrap_1.Label, { className: "font-weight-bold" }, "Content push type"),
        react_1.default.createElement(react_2.OsmosysDiv, { flexRow: true },
            react_1.default.createElement(react_2.OsmosysDiv, { className: "small cursor-pointer", marginRight: true, flexColCentered: true, onClick: () => {
                    toggle(false);
                } }, "All at once"),
            react_1.default.createElement(react_2.OsmosysDiv, null,
                react_1.default.createElement(reactstrap_1.CustomInput, { type: "switch", id: "contentPushIndividualContentItems", checked: on, onChange: e => {
                        toggle(e.target.checked);
                    } })),
            react_1.default.createElement(react_2.OsmosysDiv, { className: "small cursor-pointer", flexColCentered: true, onClick: () => {
                    toggle(true);
                } }, "One by one"))));
};
//# sourceMappingURL=ContentFeedPushIndividualItemsToggle.js.map